<template>
  <div class="ConsultationQuestionnaire">
    <div class="menu_section">
      <el-menu :default-active="menuActive" class="menu" mode="horizontal" @select="menuSelect">
        <el-menu-item v-if="![null, undefined, '', '0'].includes(doctorId)" class="menu_item" index="1">个人模版</el-menu-item>
        <el-menu-item class="menu_item" index="0">公用模版</el-menu-item>
      </el-menu>
    </div>
    <div class="content">
      <div class="header">
        <div class="condition">
          <div class="condition_label">问诊单名称</div>
          <div class="condition_value">
            <el-input placeholder="请输入" v-model="form.templateName"></el-input>
          </div>
        </div>
        <el-button type="primary" class="header_btn" @click="search">查询</el-button>
        <el-button class="header_btn" @click="reset">重置</el-button>
      </div>
      <div class="section" v-loading="loading">
        <div class="section_left">
          <div class="section_left_title">问诊单名称</div>
          <div class="section_left_list" :style="`height: calc(100% - 40px - ${(menuActive === '1') || (menuActive === '0' && [0,-1].includes(deptId)) ? '36px' : '0px'});`">
            <div v-for="temp in list" :key="temp.id" :class="{ list_item: true, active: temp.id === tempActive }" @click="tempSelect(temp)">
              <div class="list_item_name">{{ temp.templateName }}</div>
              <div v-if="(menuActive === '1') || (menuActive === '0' && [0,-1].includes(deptId))" class="list_item_operate">
                <span class="el-icon-edit-outline list_item_btn" @click.stop="toTemplateEdit(temp.id)"></span>
                <span class="el-icon-delete list_item_btn" @click.stop="templateDelete(temp.id)"></span>
              </div>
            </div>
          </div>
          <div v-if="(menuActive === '1') || (menuActive === '0' && [0,-1].includes(deptId))" class="section_left_add" @click="toTemplateEdit()">
            <span class="el-icon-plus section_left_add_icon"></span>
            <span class="section_left_add_text">新增问诊单</span>
          </div>
        </div>
        <div class="section_right">
          <div class="section_right_header">
            <div v-if="tempActive" class="section_right_title">{{ orderInfo.templateName }}</div>
            <div v-if="tempActive && ((menuActive === '1') || (menuActive === '0' && [0,-1].includes(deptId)))" class="section_right_operate">
              <el-button type="primary" class="section_right_operate_edit" @click="toTemplateEdit(orderInfo.id)">编辑</el-button>
              <el-button class="section_right_operate_del" @click="templateDelete(orderInfo.id)">删除</el-button>
            </div>
          </div>
          <div v-if="tempActive" class="section_right_content">
            <div class="order_description">{{ orderInfo.templateDescribe }}</div>
            <div class="question_list">
              <div v-for="(quest, questIndex) in orderInfo.questions" :key="quest.id" class="question_item">
                <div class="question_title">
                  <span v-if="quest.required" class="question_title_required">*</span>
                  <span class="question_title_text">{{ questIndex + 1 }}.{{ quest.questionsTitle }}</span>
                </div>
                <div v-if="quest.questionDescribe" class="question_description">{{ quest.questionDescribe }}</div>
                <div v-if="quest.sampleImages.length > 0" class="question_example">
                  <img v-for="(exampleImg, exampleImgIndex) in quest.sampleImages" :key="exampleImgIndex" class="question_example_img" :src="exampleImg">
                </div>
                <div class="question_answer">
                  <div v-if="quest.questionsType === 0" class="answer_single">
                    <el-radio v-for="ans in quest.answers" :key="ans.id" class="answer_single_radio" value="0" disabled>{{ ans.answerContent }}</el-radio>
                  </div>
                  <div v-if="quest.questionsType === 1" class="answer_multiple">
                    <el-checkbox v-for="ans in quest.answers" :key="ans.id" class="answer_multiple_checkbox" value="0" disabled>{{ ans.answerContent }}</el-checkbox>
                  </div>
                  <div v-if="quest.questionsType === 2" class="answer_shortAnswer">
                    <div v-show="quest.answerType.includes('1')" class="answer_shortAnswer_img">
                      <div class="answer_shortAnswer_img_header">
                        <div class="answer_shortAnswer_img_title">图片上传</div>
                        <div class="answer_shortAnswer_img_tips">限jpg/png文件，最多上传5张</div>
                      </div>
                      <div class="answer_shortAnswer_img_upload">
                        <span class="el-icon-plus answer_shortAnswer_upload_icon"></span>
                      </div>
                    </div>
                    <div v-show="quest.answerType.includes('2')" class="answer_shortAnswer_text">
                      <el-input class="answer_shortAnswer_text_input" placeholder="请输入" disabled></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConsultationEdit ref="consultationEdit" @submit="templateSubmit"></ConsultationEdit>
  </div>
</template>

<script>
  import { templateList, templateAdd, templateEdit, templateDelete } from '@/api/consultation-questionnaire'
  import ConsultationEdit from './components/consultationEdit.vue'
  export default {
    name: 'ConsultationQuestionnaire',
    components: {
      ConsultationEdit
    },
    data () {
      return {
        loading: false,
        deptId: '',
        doctorId: '0',
        menuActive: '0',
        tempActive: '',
        form: {
          templateName: ''
        },
        list: []
      }
    },
    created () {
      this.deptId = ![null, undefined, ''].includes(this.$session.get("deptId")) ? this.$session.get("deptId") : ''
      this.doctorId = (this.$session.get("user").hospDoctorInfo && this.$session.get("user").hospDoctorInfo.doctorId) || '0'
      if (![null, undefined, '', '0'].includes(this.doctorId)) {
        this.menuActive = '1'
      }
      this.getList()
    },
    methods: {
      async getList () {
        this.loading = true
        const res = await templateList({
          doctorId: this.menuActive === '1' ? this.doctorId : '',
          templateName: this.form.templateName,
          templateType: this.menuActive
        })
        this.loading = false
        if (res.code === 200) {
          this.list = res.rows
        }
      },
      menuSelect (index) {
        if (index !== this.menuActive) {
          this.tempActive = ''
          this.menuActive = index
          this.getList()
        }
      },
      search () {
        this.getList()
      },
      reset () {
        this.form.templateName = ''
        this.getList()
      },
      tempSelect (temp) {
        this.tempActive = temp.id
      },
      toTemplateEdit (id = null) {
        this.$refs['consultationEdit'].open(id)
      },
      templateDelete (id) {
        if (id) {
          this.$confirm('确认删除该问诊单?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await templateDelete(id)
            if (res.code === 200) {
              this.$message.success('删除成功')
              if (this.tempActive === id) {
                this.tempActive = ''
              }
              this.getList()
            }
          }).catch(() => {})
        }
      },
      async templateSubmit (info) {
        const params = {
          ...info,
          templateType: this.menuActive,
          doctorId: this.doctorId
        }
        let res = null
        if ([null, undefined, ''].includes(params.id)) {
          res = await templateAdd(params)
        } else {
          res = await templateEdit(params)
        }
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.$refs['consultationEdit'].close()
          this.getList()
        }
      }
    },
    computed: {
      orderInfo () {
        const info = this.list.find(v => v.id === this.tempActive)
        if (info) {
          const result = JSON.parse(JSON.stringify(info))
          result.questions.map(v => {
            v.answerType = [null, undefined, ''].includes(v.answerType) ? [] : v.answerType.split(',')
            v.sampleImages = [null, undefined, ''].includes(v.sampleImages) ? [] : v.sampleImages.split(',')
            return v
          })
          return result
        } else {
          return {
            id: '',
            templateName: '',
            questions: []
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .ConsultationQuestionnaire {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    overflow: hidden;
  }

  .menu_section {
    width: 100%;
    height: 56px;
    overflow: hidden;
  }

  .menu {
    box-sizing: border-box;
    padding: 0 24px;
    width: 100%;
    height: 100%;
  }

  .menu_item {
    box-sizing: border-box;
    padding: 0;
    height: 100%;
    font-weight: bold;
    font-size: 16px;
  }

  .menu_item+.menu_item {
    margin: 0 0 0 24px;
  }

  .content {
    box-sizing: border-box;
    padding: 24px;
    width: 100%;
    height: calc(100% - 56px);
    overflow: hidden;
  }

  .header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 32px;
    overflow: hidden;
  }

  .condition {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .condition_label {
    flex-shrink: 0;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }

  .condition_value {
    margin: 0 0 0 12px;
    width: 200px;
  }

  .header_btn {
    margin: 0 0 0 12px;
  }

  .section {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 20px 0 0 0;
    width: 100%;
    height: calc(100% - 32px - 20px);
    overflow: hidden;
  }

  .section_left {
    box-sizing: border-box;
    width: 300px;
    height: 100%;
    border: 1px solid #D3D3D5;
    border-radius: 2px 0 0 2px;
    overflow: hidden;
  }

  .section_left_title {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 40px;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    background-color: #F0F1F3;
    border-bottom: 1px solid #D3D3D5;
  }

  .section_left_list {
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 40px - 36px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .list_item {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 40px;
    background-color: #FFFFFF;
    border-bottom: 1px solid #D3D3D5;
  }

  .list_item.active {
    background-color: #E8F4FF;
  }

  .list_item_name {
    width: 160px;
    font-size: 14px;
    color: #000000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .list_item.active .list_item_name {
    color: #1890FF;
  }

  .list_item_operate {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .list_item_btn {
    font-size: 16px;
    color: #667182;
    cursor: pointer;
  }

  .list_item_btn+.list_item_btn {
    margin: 0 0 0 12px;
  }

  .section_left_add {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 36px;
    background-color: #FFFFFF;
    border-top: 1px solid #D3D3D5;
  }

  .section_left_add_icon {
    font-size: 14px;
    color: #000000;
  }

  .section_left_add_text {
    margin: 0 0 0 4px;
    font-size: 14px;
    color: #000000;
  }

  .section_right {
    box-sizing: border-box;
    width: calc(100% - 300px);
    height: 100%;
    background-color: #F9F9FA;
    border: 1px solid #D3D3D5;
    border-left: none;
    border-radius: 0 2px 2px 0;
    overflow: hidden;
  }

  .section_right_header {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 40px;
    background-color: #F0F1F3;
  }

  .section_right_title {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }

  .section_right_operate {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .section_right_operate_edit {
    padding: 0 10px;
    height: 28px;
  }

  .section_right_operate_del {
    margin: 0 0 0 8px;
    padding: 0 10px;
    height: 28px;
    color: #F54A45;
    border-color: #F54A45;
  }

  .section_right_content {
    box-sizing: border-box;
    padding: 12px;
    width: 100%;
    height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .order_description {
    width: 700px;
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .question_list {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .question_item {
    box-sizing: border-box;
    padding: 12px;
    width: 100%;
  }

  .question_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .question_title_required {
    font-size: 14px;
    color: #F54A45;
    vertical-align: middle;
  }

  .question_title_text {
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    vertical-align: middle;
  }

  .question_description {
    margin: 12px 0 0 0;
    width: 100%;
    line-height: 22px;
    font-size: 14px;
    color: #505050;
    white-space: pre-wrap;
  }

  .question_example {
    margin: 12px -12px -12px 0;
    width: 100%;
  }

  .question_example_img {
    margin: 0 12px 12px 0;
    width: 80px;
    height: 80px;
  }

  .question_answer {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .answer_single {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  
  .answer_single_radio+.answer_single_radio {
    margin: 12px 0 0 0;
  }

  .answer_multiple {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .answer_multiple_checkbox+.answer_multiple_checkbox {
    margin: 12px 0 0 0;
  }

  .answer_shortAnswer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .answer_shortAnswer_img {
    margin: 0 0 0 0;
  }

  .answer_shortAnswer_img_header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
  }

  .answer_shortAnswer_img_title {
    line-height: 18px;
    font-size: 14px;
    color: #323233;
  }

  .answer_shortAnswer_img_tips {
    margin: 0 0 0 6px;
    line-height: 18px;
    font-size: 12px;
    color: #606266;
  }

  .answer_shortAnswer_img_upload {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0 0 0;
    width: 148px;
    height: 148px;
    background-color: #F9F9FA;
    border: 1px dashed #DCDFE6;
    border-radius: 6px;
  }

  .answer_shortAnswer_upload_icon {
    font-size: 28px;
    color: #303133;
  }

  .answer_shortAnswer_text {
    margin: 20px 0 0 0;
    width: 100%;
  }

  .answer_shortAnswer_text_input {
    width: 100%;
  }

  .answer_shortAnswer_text_input.is-disabled /deep/ .el-input__inner {
    background-color: #F9F9FA;
    border-color: #D3D3D5;
  }
</style>